"use strict";
/*
 * Created on 09 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link SiteReleaseTerminationItem}.</p>
 *
 * @author Jaroslav Sevcik
 */


var SiteReleaseTerminationItemConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SiteReleaseTerminationItemConverter, _DataObjectConverter_);

  function SiteReleaseTerminationItemConverter() {
    _classCallCheck(this, SiteReleaseTerminationItemConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseTerminationItemConverter).apply(this, arguments));
  }

  return SiteReleaseTerminationItemConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SiteReleaseTerminationItemConverter = SiteReleaseTerminationItemConverter;